module.exports = __webpack_public_path__ + "img/academia.2f717c8e.svg";